<script setup lang="ts">
import Button from '../../components/button/Button.vue';
import Icon from './components/Icon.vue';

const reload = () => location.reload();
</script>

<template>
  <div class="flex flex-col justify-center items-center">
    <Icon />

    <div class="flex flex-col justify-center items-center gap-2">
      <span class="text-[25px] font-normal text-center leading-8">{{ $t('maintenance.downForMaintenance') }}</span>

      <p class="text-muted-foreground">
        {{ $t('maintenance.backShortly') }}
      </p>

      <Button
        class="mt-6"
        variant="primary"
        @click="reload"
      >
        {{ $t('maintenance.reload') }}
      </Button>
    </div>
  </div>
</template>
